import { boolean, index, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { candidates } from './candidates';
import { jobs } from './jobs';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const interviewSessionStatusEnum = pgEnum('interview_session_status', [
  'pending',
  'in_progress',
  'completed',
  'expired'
]);

export const interviewMessageRoleEnum = pgEnum('interview_message_role', [
  'assistant',
  'candidate'
]);

export type InterviewMessageRole = (typeof interviewMessageRoleEnum.enumValues)[number];

export const interviewSessions = pgTable(
  'interview_sessions',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    applicationId: uuid('application_id')
      .notNull()
      .references(() => applications.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    jobId: uuid('job_id')
      .notNull()
      .references(() => jobs.id),
    token: text('token').notNull().unique(),
    status: interviewSessionStatusEnum('status').notNull().default('pending'),
    language: text('language'),
    modality: text('modality').notNull().default('text'),
    startedAt: timestamp('started_at'),
    completedAt: timestamp('completed_at'),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    index('interview_sessions_application_id_idx').on(t.applicationId),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();

export const interviewMessages = pgTable(
  'interview_messages',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    sessionId: uuid('session_id')
      .notNull()
      .references(() => interviewSessions.id),
    role: interviewMessageRoleEnum('role').notNull(),
    content: text('content').notNull(),
    copyPasteDetected: boolean('copy_paste_detected').notNull().default(false),
    createdAt: timestamp('created_at').notNull().defaultNow()
  },
  () => [tenantOrgIsolationPolicy()]
).enableRLS();
